"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

var _Array$from = require("@babel/runtime-corejs3/core-js/array/from");

var _sliceInstanceProperty = require("@babel/runtime-corejs3/core-js/instance/slice");

var _getIteratorMethod = require("@babel/runtime-corejs3/core-js/get-iterator-method");

var _Symbol = require("@babel/runtime-corejs3/core-js/symbol");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.parseSRT = parseSRT;

var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/array/is-array"));

var _isNan = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/number/is-nan"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/concat"));

var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/trim"));

var _parseInt2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/parse-int"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/map"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { var _context5; if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = _sliceInstanceProperty(_context5 = Object.prototype.toString.call(o)).call(_context5, 8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return _Array$from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof _Symbol !== "undefined" && _getIteratorMethod(arr) || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if ((0, _isArray.default)(arr)) return arr; }

var SEC_PER_HOUR = 3600;

function parseTimeStamp(timeStr) {
  var _context;

  var _timeStr$split = timeStr.split(','),
      _timeStr$split2 = _slicedToArray(_timeStr$split, 2),
      time = _timeStr$split2[0],
      mill = _timeStr$split2[1];

  var _time$split$map = (0, _map.default)(_context = time.split(':')).call(_context, function (comp) {
    return (0, _parseInt2.default)(comp);
  }),
      _time$split$map2 = _slicedToArray(_time$split$map, 3),
      hour = _time$split$map2[0],
      min = _time$split$map2[1],
      sec = _time$split$map2[2];

  return hour * SEC_PER_HOUR * 1000 + min * 60 * 1000 + sec * 1000 + (0, _parseInt2.default)(mill);
}

function parseSRT(source) {
  var res = [];
  var trimmedSource = (0, _trim.default)(source).call(source);

  if (!trimmedSource) {
    return res;
  }

  var lines = trimmedSource.split(/\r?\n/);
  var currLine = 0;

  function throwParseError(expected) {
    var _context2, _context3;

    throw new Error((0, _concat.default)(_context2 = (0, _concat.default)(_context3 = "Parse Error: Illegal SRT file, expected ".concat(expected, " but received ")).call(_context3, lines[currLine], " in line ")).call(_context2, currLine, "."));
  }

  var parseLineNumLine = function parseLineNumLine() {
    var lineNumber = (0, _parseInt2.default)(lines[currLine]);

    if ((0, _isNan.default)(lineNumber)) {
      throwParseError('line number');
    }

    currLine++;
    return lineNumber;
  };

  var parseTimeStampLine = function parseTimeStampLine() {
    var _context4;

    var _lines$currLine$split = (0, _map.default)(_context4 = lines[currLine].split('-->')).call(_context4, function (str) {
      return parseTimeStamp((0, _trim.default)(str).call(str));
    }),
        _lines$currLine$split2 = _slicedToArray(_lines$currLine$split, 2),
        start = _lines$currLine$split2[0],
        end = _lines$currLine$split2[1];

    if ((0, _isNan.default)(start) || (0, _isNan.default)(end)) {
      throwParseError('time');
    }

    currLine++;
    return [start, end];
  };

  var parseTextLines = function parseTextLines() {
    var text = [];

    while (currLine < lines.length && lines[currLine] !== '') {
      text.push(lines[currLine]);
      currLine++;
    }

    return text;
  };

  var parseBlankLine = function parseBlankLine() {
    currLine++;
  };

  var parseSRTLine = function parseSRTLine() {
    /**
     * Each subtitle has four parts in the SRT file.
       1. A numeric counter indicating the number or position of the subtitle.
      2. Start and end time of the subtitle separated by -–> characters
      3. Subtitle text in one or more lines.
      4. A blank line indicating the end of the subtitle.
     */
    var lineNumber = parseLineNumLine();

    var _parseTimeStampLine = parseTimeStampLine(),
        _parseTimeStampLine2 = _slicedToArray(_parseTimeStampLine, 2),
        start = _parseTimeStampLine2[0],
        end = _parseTimeStampLine2[1];

    var text = parseTextLines();
    parseBlankLine();
    res.push({
      id: lineNumber,
      start: start,
      end: end,
      text: text.join('<br/>')
    });
  };

  while (currLine < lines.length) {
    parseSRTLine();
  }

  return res;
}